import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ErrorModalHelperService } from "../../_helpers/error-modal-helper/error-modal-helper.service";
import { DigitalClassroomAccess } from "../../_models/digital-classroom/digital-classroom-access.model";
import { ClientService, PlacementService } from "../../_services";
import { BaseComponent } from "../../base.component";
import { FeatureHelperService } from "../../_helpers/feature-helper/feature-helper.service";
import { ThemeService } from "../../_helpers/theming-engine/theme.service";
import { ReportClient } from "../../_models/reports/report-client.model";

@Component({
    selector: "app-online-lesson-overview",
    templateUrl: "./online-lesson-overview.component.html",
    styleUrls: ["./online-lesson-overview.component.css"],
    standalone: false
})
export class OnlineLessonOverviewComponent
  extends BaseComponent
  implements OnInit
{
  public OnlineOverviewClient: boolean = false;
  /**
   * The all-rooms (SuperUser) overview. Governed by VideoLibraryAllRooms — the one feature behind every
   * Digital Classroom SuperUser launch — not OnlineOverviewAdmin. The API enforces the same rule.
   */
  public OnlineOverviewAllRooms: boolean = false;
  public clients: ReportClient[] = [];

  private user: any;

  constructor(
    public themeService: ThemeService,
    public errorModalHelper: ErrorModalHelperService,
    private featureHelperService: FeatureHelperService,
    public dialog: MatDialog,
    private placementService: PlacementService,
    private clientService: ClientService
  ) {
    super();
  }

  ngOnInit(): void {

    this.getAccess();
    this.user = this.authService.userSessionData.currentUser;
    
    this.clientService.GetClientsForClassroomOverview(this.user.id).subscribe({
      next:(response: ReportClient[]) =>{
        this.clients = response;
      },
      error: (error: any) => {
        this.errorModalHelper.show(error.message, error);
        this.router.navigate(["/bookings"]);
      },
    });

    // debugger;
    // if (this.OnlineOverviewClient) {
    //   this.clientService.GetReportClients(this.user.id).subscribe({
    //     next: (response: ReportClient[]) => {
    //       this.clients = response;
    //       this.loading = false;
    //     },
    //     error: (error: any) => {
    //       this.errorModalHelper.show(error.message, error);
    //       this.loading = false;
    //       this.router.navigate(["/bookings"]);
    //     },
    //   });
    // }

  }

  getAccess() {
    let featureList = new Array<string>();
    featureList.push("OnlineOverviewClient");

    let currentUserFeatures =
      this.featureHelperService.checkFeaturePermissions(featureList);

    featureList.forEach((feature) => {
      let userFeatureIndex = currentUserFeatures.findIndex(
        (f) => f.feature.toLowerCase() === feature.toLowerCase()
      );

      if (userFeatureIndex > -1) {
        this[feature] = currentUserFeatures[userFeatureIndex].enabled;
      }
    });

    this.OnlineOverviewAllRooms = this.featureHelperService.hasFeature("VideoLibraryAllRooms");
  }

  /** A client's buttons open that client's rooms (isSuperUser false); the all-rooms button passes true. */
  public launchOnlineOverview(isSuperUser: boolean, clientId: number = 0, clientName: string = '') {
    this.placementService
      .launchOnlineOverview({
        userId: this.user.id,
        isSuperUser: isSuperUser && this.OnlineOverviewAllRooms,
        clientId: clientId,
        clientName: clientName
      })
      .subscribe(
        (access: DigitalClassroomAccess) => {
          setTimeout(() => {
            window.open(access.accessToken, "_blank");
          }, 0);
        },
        (error) => {
          let errorMessage =
            error.status === 401 ? "Unauthorized" : error.message;
          if (
            errorMessage ==
            "Object reference not set to an instance of an object."
          ) {
            errorMessage = "Client not found. Try another.";
          }
          this.errorModalHelper.show(errorMessage, error);
        }
      );
  }

  getArray(length: number): number[] {
    return Array.from({ length }, (_, index) => index + 1);
  }
}
